// extracted by mini-css-extract-plugin
module.exports = {"cell":"style-module_cell__EB7QyQdIC0wRwfZO5Sfv3"};